// eslint-disable-next-line
export default function ({ route, redirect }) {
  console.log(route.params);
  const product2025AllowedMediaTypes = [
    'stock-video',
    'stock-music',
    'stock-image',
    'gif',
    'video',
    'music',
    'image',
  ];
  const mediaType = route.params.mediaType;
  if (!product2025AllowedMediaTypes.includes(mediaType)) {
    console.log('========= product2025 full page redirect');
    redirect('/');
  }
}
